import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography,} from "@mui/material";
import {useState} from "react";
import {printReport} from "../../http/api/ReportSaveAPI";
import PrintPreview from "../../pages/invoice/PrintManagePage/PrintPreview";
import useInputObject from "../../hooks/useInputObject";

const SalesRecordPrintDialog = (props) => {
    const {open, onClose} = props;
    const [salesRecordNos, setSalesRecordNos] = useState("");
    const [loading, setLoading] = useState(false);
    const printPreview = useInputObject({open: false, url: ""});

    const handleSubmit = async () => {
        if (!salesRecordNos.trim()) {
            alert("販売原票番号を入力してください");
            return;
        }

        const listSalesRecordNo = salesRecordNos
            .split(",")
            .map((no) => no.trim())
            .filter((no) => no);

        setLoading(true);
        try {
            const response = await printReport({
                reportTypeId: 22,
                printParameter: {listSalesRecordNo},
                targetDate: new Date(),
            });

            const blob = new Blob([response], {
                type: "application/pdf",
                encoding: "UTF-8",
            });
            const fileUrl = URL.createObjectURL(blob);
            printPreview.updates({open: true, url: fileUrl});
        } catch (e) {
            console.error("Print error:", e);
            alert("印刷エラーが発生しました");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSalesRecordNos("");
        onClose();
    };

    return (
        <>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>販売原票QR印刷（開発者用）</DialogTitle>
                <DialogContent>
                    <Box sx={{mt: 2}}>
                        <Typography variant="body2" sx={{mb: 1}}>
                            販売原票番号をカンマ区切りで入力してください:
                        </Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            value={salesRecordNos}
                            onChange={(e) => setSalesRecordNos(e.target.value)}
                            placeholder="例: 12345, 67890, 11111"
                            disabled={loading}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={loading}>
                        キャンセル
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={loading}
                    >
                        {loading ? "印刷中..." : "印刷"}
                    </Button>
                </DialogActions>
            </Dialog>
            <PrintPreview printPreview={printPreview}/>
        </>
    );
};

export default SalesRecordPrintDialog;
